const {h, render, Component} = require('preact');
const Helper = require('../../../helper')

const COOKIE_NAME = 'mb_hide';

class MarketingBanner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // showBanner flag shall be true if there's no cookie and feature flag is enabled
      showBanner: !Helper.readCookie(COOKIE_NAME) && Helper.isFeatureFlagEnabled('showMarketingBannerWeb'),
      faqUrl: Groupon.Utils.getConfigFromDom().marketingBannerFAQ,
      imageUrl: Groupon.Utils.getConfigFromDom().marketingBannerImgUrl
    }
    this.handleHideBanner = this.handleHideBanner.bind(this);
  }

  handleHideBanner() {
    Helper.setCookie(COOKIE_NAME, true); // set the cookie, so it the banner does not appear for user again.
    this.setState({ showBanner: false });
  }

  render() {
    if (!this.state.showBanner) {
      return;
    }
    return (
      <div class="marketing_banner">
        <span class="hide-link" onClick={this.handleHideBanner}></span>
        <a href={this.state.faqUrl}>
          <img 
            src={this.state.imageUrl}
            alt="flexible exchange and refund policies banner" id="web_2018-marketing-banner"
            data-bhw="contact_us_web_2018_marketing_banner" />
        </a>
      </div>
    );
  }
}

module.exports = MarketingBanner;